import { createFileRoute } from '@tanstack/react-router'
import MyTasksPage from '@/pages/(protected)/workspaces/[workspaceId]/compliance/tasks'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/tasks/'
)({
  component: MyTasksPage,
})

